import { PHASE_ORDERING } from '../../constants';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import EmptyState from 'components/EmptyState';

import RecommendationRow from 'pages/MaintenancePage/components/RecommendationRow';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const RecommendedPartsSection: FunctionComponent<Props> = ({
    className = '',
    droneNames,
    onAdd,
    phase,
    recommendations,
    testId = TEST_ID
}) => {
    const { COMING_SOON, NO_PARTS_FLEET, RECOMMENDED_PARTS } = useTranslation();
    const countLabel = `${recommendations.length}`;
    const canAddToCart = phase >= PHASE_ORDERING;

    return (
        <VerticalContainer className={`${styles.recommendedSection} ${className}`} testId={testId}>
            <HorizontalContainer className={styles.recommendedHead}>
                <HorizontalContainer className={styles.recommendedTitleGroup}>
                    <Wrapper className={styles.recommendedTitle}>{RECOMMENDED_PARTS}</Wrapper>

                    <Wrapper className={styles.comingSoonBadge}>{COMING_SOON}</Wrapper>
                </HorizontalContainer>

                <Wrapper className={styles.recommendedCount}>{countLabel}</Wrapper>
            </HorizontalContainer>

            {recommendations.length === 0 ? (
                <EmptyState text={NO_PARTS_FLEET} />
            ) : (
                recommendations.map(recommendation => (
                    <RecommendationRow
                        canAddToCart={canAddToCart}
                        droneNames={droneNames}
                        key={recommendation.partId}
                        onAdd={onAdd}
                        recommendation={recommendation}
                    />
                ))
            )}
        </VerticalContainer>
    );
};

export default RecommendedPartsSection;
